import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const AntiScrapingGuard = ({ children }: { children: React.ReactNode }) => {
  const [isBot, setIsBot] = useState(false);
  const [requestCount, setRequestCount] = useState(0);
  const location = useLocation();

  useEffect(() => {
    // Détection basique des bots
    const userAgent = navigator.userAgent.toLowerCase();
    const botPatterns = [
      'bot', 'crawl', 'spider', 'scrape', 'slurp', 'index',
      'phantom', 'puppeteer', 'selenium', 'headless'
    ];
    
    const isLikelyBot = botPatterns.some(pattern => userAgent.includes(pattern));
    
    // Vérification du comportement humain
    const hasMouseMoved = sessionStorage.getItem('mouse_moved') === 'true';
    const hasInteracted = sessionStorage.getItem('user_interacted') === 'true';
    
    // Rate limiting basique
    const requests = parseInt(sessionStorage.getItem('request_count') || '0');
    setRequestCount(requests + 1);
    sessionStorage.setItem('request_count', (requests + 1).toString());
    
    if (isLikelyBot || (!hasMouseMoved && !hasInteracted && requests > 10)) {
      setIsBot(true);
      console.warn('⚠️ Comportement suspect détecté');
    }

    // Tracker les interactions humaines
    const trackMouseMove = () => {
      sessionStorage.setItem('mouse_moved', 'true');
    };
    
    const trackInteraction = () => {
      sessionStorage.setItem('user_interacted', 'true');
    };

    document.addEventListener('mousemove', trackMouseMove, { once: true });
    document.addEventListener('click', trackInteraction);
    document.addEventListener('keydown', trackInteraction);
    
    return () => {
      document.removeEventListener('mousemove', trackMouseMove);
      document.removeEventListener('click', trackInteraction);
      document.removeEventListener('keydown', trackInteraction);
    };
  }, []);

  // Pages publiques autorisées au scraping
  const publicPages = ['/', '/missions', '/prestataires', '/contact', '/carte', '/tarifs'];
  const isPublicPage = publicPages.includes(location.pathname);
  
  // Pages privées protégées
  const isPrivatePage = location.pathname.startsWith('/dashboard') || 
                       location.pathname.startsWith('/admin') ||
                       location.pathname.includes('onboarding');

  // Protection pour les pages privées uniquement - Désactivé temporairement pour debug
  if (false && (isBot || requestCount > 50) && isPrivatePage) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold">QuiQuoiOùQuand</h1>
          <p className="text-muted-foreground mt-2">
            Plateforme de mise en relation professionnelle
          </p>
          <p className="text-sm text-muted-foreground mt-4">
            Pour accéder au contenu complet, veuillez utiliser un navigateur standard.
          </p>
        </div>
      </div>
    );
  }

  // Pour la page carte, masquer les adresses si c'est un bot
  if (isBot && location.pathname === '/carte') {
    // Marquer dans sessionStorage pour indiquer aux composants de masquer les adresses
    sessionStorage.setItem('hide_addresses_for_bots', 'true');
  } else {
    sessionStorage.removeItem('hide_addresses_for_bots');
  }

  return <>{children}</>;
};